var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{staticClass:"my-checkbox",attrs:{"size":"lg","value":_vm.checkedValue,"unchecked-value":_vm.uncheckedValue,"disabled":_vm.disabled},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }